/* eslint-disable */
import { FILTER_ADDRESS_UNSELECTED } from '../Filters.types';

/**
 * Action to unselect the address from the filters
 * @param {Array} address The address
 * @returns {ActionCreator<FromPayload<Array<string>, ActionMeta, FILTER_ADDRESS_UNSELECTED>>} The created `Action`
 */
const filtersUnselectAddress = (address) => ({ fromPayload }) => {
  return fromPayload(address, { debounce: true }, FILTER_ADDRESS_UNSELECTED);
};

export default filtersUnselectAddress;
